import 'angular';
import './new_approvals_request_panel.html'
import './NewApprovalRequestPanelController'

angular.module("GorillaBoy")
.directive('newApprovalRequestPanel', () => {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: './approvals/newApprovalRequestPanel/new_approvals_request_panel.html',
        controller: 'NewApprovalRequestPanelController'
    };
});
